import request from './utils/request'

class JobService {
  static getJobs(page = 1) {
    return request('GET', 'job/job/', undefined, { page })
  }

  static getJob(id) {
    return request('GET', `job/job/${id}`)
  }

  static addJob(data) {
    return request('POST', 'job/job/', data)
  }

  static editJob(id, data) {
    return request(
      'PUT',
      `job/job/${id}`,
      data,
      {},
      {
        'Content-Type': 'multipart/form-data',
      }
    )
  }

  static deleteJob(id) {
    return request('DELETE', `job/job/${id}`)
  }

  static searchJobs(params = {}) {
    return request('GET', 'job_search/jobs/', params)
  }
}

export default JobService
